<template>
	<div>
		<section class="discount-applied text-center d-none d-md-block">
			<p class="mb-0">
				<i class="fal fa-badge-check discount-applied-icon"></i>
				Your {{ discount }}% Discount Code Has Been Successfully
				Applied!
			</p>
		</section>

		<!-- Header -->
		<header
			class="container-fluid container top-header p-md-0 py-lg-4 d-none d-md-block"
		>
			<ul class="d-flex justify-content-between align-items-center">
				<li class="py-md-4 py-lg-0">
					<a href="https://shop.ohowatch.com" target="_blank"
						><img
							class="logo"
							src="@/assets/img/v1/oho-pro-logo-coloured.png"
							alt="OHO Pro is a cheap, stylish, smartwatch with lots of features"
					/></a>
				</li>
				<li
					class="d-md-flex d-lg-inline flex-wrap justify-content-center header-policy-item"
				>
					<i class="fal fa-shipping-fast"></i> Free shipping today!
				</li>
				<li
					class="d-md-flex d-lg-inline flex-wrap justify-content-center header-policy-item"
				>
					<i class="fal fa-badge-check"></i> Customer Satisfaction
					Policy
				</li>
				<li
					class="d-md-flex d-lg-inline flex-wrap justify-content-center header-policy-item"
				>
					<i class="fal fa-user-headset"></i> Online Support 24/7
				</li>
			</ul>
		</header>

		<!-- Slider Section -->
		<section class="container-fluid slider p-0">
			<div class="container">
				<div class="row align-items-center">
					<div class="col-md-7">
						<div
							class="text-center logo-white-container d-block d-md-none"
						>
							<section
								class="discount-applied-mobile text-center"
							>
								<p class="mb-0 d-flex align-items-center">
									<i
										class="fal fa-badge-check mr-3 discount-applied-icon"
									></i>
									Your {{ discount }}% Discount Code Has Been
									Successfully Applied!
								</p>
							</section>
							<img
								class="logo-white"
								src="@/assets/img/v1/logo-new-white.png"
								alt="OHO Pro is a cheap, stylish, smartwatch with lots of features"
							/>
						</div>
						<h1 class="main-tagline">
							Stay Active. Stay Healthy. Stay Connected.
						</h1>
						<div
							class="main-cta pulsate-fwd float-md-left text-center top-cta-main pb-lg-0"
						>
							<a href="#select-your-oho-pro" class="mybtn1"
								><span>Select Your Watches</span>
							</a>
						</div>
					</div>
					<div class="col-md-5 checkout-main-image">
						<img
							src="@/assets/img/v1/oho-pro-checkout-watches.png"
							alt="OHO Pro Official Discount Checkout. Where can I buy a OHO Pro smartwatch?"
						/>
					</div>
				</div>
			</div>

			<div class="features">
				<div class="container">
					<div class="features-block-container">
						<h1 class="text-center">
							Reasons why you’ll love OHO Pro&trade;
						</h1>
						<div class="row m-0">
							<div class="col-lg-3 features-block">
								<i class="fa fa-chart-line fa-2x"></i>
								<p>
									Track your activity. Never miss a single
									step or calorie.
								</p>
							</div>
							<div class="col-lg-3 features-block">
								<i class="fa fa-child fa-2x"></i>
								<p>
									Walk, run, cycle, yoga, workouts - you can
									track all exercises!
								</p>
							</div>
							<div class="col-lg-3 features-block">
								<i class="fa fa-heartbeat fa-2x"></i>
								<p>
									Check your blood O<sup>2</sup>, blood
									pressure, heart rate and sleep for signs of
									illness and stress.
								</p>
							</div>
							<div class="col-lg-3 features-block">
								<i class="fa fa-shopping-bag fa-2x"></i>
								<p>
									Stylish, elegant and comfortable, wear yours
									for any occasion.
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	props: {
		discount: {
			type: Number,
			default: 20,
		},
	},
}
</script>

<style lang="scss" scoped>
</style>